import { faArrowLeft, faShoppingBag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Drawer } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CartRecap } from '../../views/cartRecap';

import './style.scss';

const selectTotal = (state) => {
  return state.cart.ids.reduce((acc, id) => {
    return acc + (state.cart.qty[id] || 0);
  }, 0);
};

export const AppHeader = ({ back, title }) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const total = useSelector(selectTotal);

  return (
    <div className="app-header">
      <div
        className="back"
        onClick={() => {
          if (back) {
            history.goBack();
          }
        }}
      >
        {Boolean(back) && <FontAwesomeIcon icon={faArrowLeft} />}
      </div>
      <div className="title">{title}</div>
      <div className="cart-icon" onClick={() => setOpen(true)}>
        <Badge count={total} size="small">
          <FontAwesomeIcon style={{ fontSize: 18 }} icon={faShoppingBag} />
        </Badge>
      </div>
      <Drawer
        className="app-drawer"
        visible={open}
        onClose={() => setOpen(false)}
      >
        <CartRecap />
      </Drawer>
    </div>
  );
};
